/* eslint-disable react/jsx-curly-brace-presence */
const LoadingTextBlock = () => (
  <div className="p-4 mb-1 animate-loadingTextBlock rounded-lg  bg-sand-200 ">
    <p className="text-neutral-600 line-clamp-3">
      {
        "Il est difficile de savoir combien d'années cette période a réellement duré. Durant cette époque troublée, peu se souciaient de mesurer le temps avec acuité... Il est toutefois communément admis que la Grande Errance a duré entre cent et cent cinquante ans. Durant ce laps de temps, des légendes ont survécu : celles des Nomades du Tumulte. Les rares survivants se sont agrégés en grandes Tribus qui parcouraient le monde, voyageant d'Oasis en Oasis, de lieux protégés du Tumulte en abris de fortune."
      }
    </p>
  </div>
);

export default LoadingTextBlock;
